import type { PublicTokenRegistryItem } from '@arhs-fleetback/types/entities/public-tokens';

import * as types from 'modules/publicToken/actionTypes';
import { LOCATION_CHANGE } from 'modules/router/actionTypes';
import { createEntityAdapter, createReducer } from 'utils/ReduxUtils';

const publicTokenAdapter = createEntityAdapter<PublicTokenRegistryItem>({
  selectId: ({ id }) => id,
});

export default createReducer(publicTokenAdapter.getInitialState(), {
  [types.FETCH_PUBLIC_TOKEN_SUCCESS]: publicTokenAdapter.setAll,
  [types.CREATE_PUBLIC_TOKEN_SUCCESS]: publicTokenAdapter.addOne,
  [types.DELETE_PUBLIC_TOKEN_SUCCESS]: publicTokenAdapter.removeOne,
  [types.UPDATE_PUBLIC_TOKEN_STATUS_SUCCESS]: publicTokenAdapter.updateOne,
  [LOCATION_CHANGE]: publicTokenAdapter.removeAll,
});
